import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "./url-handler.service";

const ShotsApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
    console.log("ShotsApiService URL:", this.URL);
  },

  /**
   * Search shots by administrator with filtering
   * @param {Object} params - Query parameters
   * @param {number} [params.userId] - Filter by user ID (exact match)
   * @param {string} [params.userEmail] - Filter by user email (partial match, case-insensitive)
   * @param {string} [params.username] - Filter by username (partial match, case-insensitive)
   * @param {number} [params.page] - Page number (default: 0)
   * @param {number} [params.size] - Page size (default: 20)
   * @returns {Promise}
   */
  search(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.userId) queryParams.append("userId", params.userId);
    if (params.userEmail) queryParams.append("userEmail", params.userEmail);
    if (params.username) queryParams.append("username", params.username);
    queryParams.append("page", params.page || 0);
    queryParams.append("size", params.size || 20);

    return Vue.axios.get(`${this.URL}api/social/shots/admin/search?${queryParams}`, {
      ignoreCountryId: true
    });
  },

  /**
   * Delete shot by administrator
   * @param {string} videoId - Video identifier of the shot
   * @returns {Promise}
   */
  delete(videoId) {
    return Vue.axios.delete(`${this.URL}api/social/shots/admin/${videoId}`, {
      ignoreCountryId: true
    });
  }
};

export default ShotsApiService;
